export default __webpack_public_path__ + "static/Fungal_Wood_(Aberration)-39d635954c422c378617ab0b5389b837.png";